<script lang="ts">
    import InputText from "./InputText.svelte";
    import { z } from 'zod';

    export let value: string = '';
    export let disabled: boolean = false;
    export let placeholder: string = '';

    export let style: string = '';
    export let markDirty: boolean = false;

    let isDirty: boolean = false;
    let isValid: boolean = false;

    export let onValidation: (valid: boolean, dirty: boolean) => void = ()  => {}

    $: {
        isDirty = value.length > 0 || markDirty;
        isValid = z.string().email().safeParse(value).success;
        onValidation(isValid, isDirty);
    }


</script>

<InputText bind:value={value} style={isDirty&&!isValid ? style + '; border-color:red;' : style} placeholder={placeholder} on:change />

<style>
    .invalid {
        border-color: red;
    }
</style>
